// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LRXk","rootNoMargin":"styles_rootNoMargin__2xWZ3"};